import { useHistory } from 'react-router-dom';
import qs from 'query-string';
import { useCallback, useMemo } from 'react';

type UpdateQuery = (query: any, replace?: boolean) => void;

export const useQuery = <TQuery = any>(): [TQuery, UpdateQuery] => {
  const history = useHistory();

  const query = (useMemo(() => {
    return qs.parse(history.location.search);
  }, [history.location.search]) as any) as TQuery;

  const updateQuery = useCallback(
    (properties: Object, replace = false) => {
      const newQuery: any = replace ? properties : { ...query, ...properties };
      history.push(history.location.pathname + '?' + qs.stringify(newQuery));
    },
    [query, history.location]
  );

  return [query, updateQuery];
};
